import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import styled from "styled-components";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import MobileNav from "../../components/MobileNav";
import tick from "../../assets/tick.png";

const Signup = () => {
  const [toggleProgress, setToggleProgress] = useState(1);
  const progressBtn = (index) => {
    setToggleProgress(index);
  };
  return (
    <div className="bg">
      <Header />
      <MobileNav />
      <RegisterMain>
        <RegisterCard>
          <RegisterHeader>
            <div>
              <Link to="/sign-in">
                <MdKeyboardArrowLeft className="icon" />
                Back
              </Link>
            </div>
            <Progress>
              <div
                className={toggleProgress === 1 ? "active" : "deactive"}
                onClick={() => progressBtn(1)}
              ></div>
              <div
                className={toggleProgress === 2 ? "active" : "deactive"}
                onClick={() => progressBtn(2)}
              ></div>
              <div
                className={toggleProgress === 3 ? "active" : "deactive"}
                onClick={() => progressBtn(3)}
              ></div>
              <div
                className={toggleProgress === 4 ? "active" : "deactive"}
                onClick={() => progressBtn(4)}
              ></div>
              <div
                className={toggleProgress === 5 ? "active" : "deactive"}
                onClick={() => progressBtn(5)}
              ></div>
            </Progress>
          </RegisterHeader>
          {toggleProgress === 1 ? (
            <Form>
              <h4>Personal Details</h4>
              <div className="grid">
                <div className="formDiv">
                  <label>First Name*</label>
                  <input type="text" />
                </div>
                <div className="formDiv">
                  <label>Last Name*</label>
                  <input type="text" />
                </div>
                <div className="formDiv">
                  <label>Mobile No*</label>
                  <input type="number" />
                </div>
                <div className="formDiv">
                  <label>Email Id*</label>
                  <input type="text" />
                </div>
              </div>
              <div className="formDiv mTop">
                <label>Address*</label>
                <textarea name="" id="" cols="30" rows="10"></textarea>
              </div>
              <button onClick={() => progressBtn(2)}>Next</button>
            </Form>
          ) : null}
          {toggleProgress === 2 ? (
            <Form>
              <h4>Company Details</h4>
              <div className="grid">
                <div className="formDiv">
                  <label>Company Name*</label>
                  <input type="text" />
                </div>
                <div className="formDiv">
                  <label>Last Name*</label>
                  <input type="text" />
                </div>
                <div className="formDiv">
                  <label>Mobile No*</label>
                  <input type="number" />
                </div>
                <div className="formDiv">
                  <label>Email Id*</label>
                  <input type="text" />
                </div>
              </div>
              <div className="formDiv mTop">
                <label>Address*</label>
                <textarea name="" id="" cols="30" rows="10"></textarea>
              </div>
              <button>Next</button>
            </Form>
          ) : null}
          {toggleProgress === 5 ? (
            <Complete>
              <img src={tick} alt="" />
              <h3>User Registration Succesfull</h3>
            </Complete>
          ) : null}
        </RegisterCard>
      </RegisterMain>
      <Footer />
    </div>
  );
};

export default Signup;

const RegisterMain = styled.div`
  padding: 4rem calc((100vw - 1000px) / 2);
`;

const RegisterCard = styled.div`
  background-color: #fff;
  width: 700px;
  margin: auto;
  padding: 20px 20px;
  border-radius: 8px;

  @media only screen and (max-width: 991px) {
    width: 700px;
  }
  @media only screen and (max-width: 540px) {
    width: 500px;
  }
  @media only screen and (max-width: 414px) {
    width: 400px;
  }
  @media only screen and (max-width: 393px) {
    width: 380px;
  }
  @media only screen and (max-width: 375px) {
    width: 365px;
  }
  @media only screen and (max-width: 360px) {
    width: 350px;
  }
`;

const RegisterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgb(32, 32, 79);
      font-size: 15px;
      .icon {
        font-size: 22px;
        margin-right: 7px;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    div {
      a {
        margin-bottom: 0.7rem;
      }
    }
  }
`;

const Progress = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    padding: 3px;
    width: 55px;
    border-radius: 8px;
    margin-left: 10px;
    cursor: pointer;
  }
  .deactive {
    background-color: #d6e7f5;
  }
  .active {
    background-color: rgb(58, 170, 53);
  }
`;

const Form = styled.div`
  margin-top: 1rem;
  h4 {
    font-weight: 500;
    font-size: 25px;
    color: rgb(32, 32, 79);
  }
  .mTop {
    margin-top: 0.5rem;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 0.5rem;
    grid-column-gap: 1rem;
    margin-top: 0.8rem;
  }
  .formDiv {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;

    label {
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 5px;
      color: #20204f;
    }
    input {
      width: 100%;
      border: none;
      outline: none;
      border: 2px solid #3aaa35;
      padding: 7px 10px;
      border-radius: 5px;
      font-size: 15px;
      font-weight: 500;
      color: #20204f;
    }
    textarea {
      width: 100%;
      height: 100px;
      border: none;
      outline: none;
      border: 2px solid #3aaa35;
      padding: 7px 10px;
      border-radius: 5px;
      font-size: 15px;
      font-weight: 500;
      color: #20204f;
    }
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    padding: 7px 15px;
    width: 100%;
    border: none;
    outline: none;
    background-color: #3aaa35;
    color: #fff;
    border-radius: 5px;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    margin-top: 1rem;
  }
  @media only screen and (max-width: 991px) {
    .grid {
      grid-template-columns: 1fr;
      grid-gap: 0.5rem;
      grid-column-gap: 1rem;
      margin-top: 0.8rem;
    }
  }
`;

const Complete = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    width: 250px;
    height: 250px;
    margin-top: 0.8rem;
  }
  h3 {
    font-size: 25px;
    color: rgb(32, 32, 79);
  }
`;
